export default "__VITE_ASSET__fa5e5f27__"